import { Transform } from 'class-transformer';

export function NilToNull() {
  return Transform(({ value }) => {
    if (typeof value !== 'string') return value;

    // Return value if value is empty
    if (value.toUpperCase() === 'NIL') return null;

    return value;
  });
}
